/* eslint-disable react/no-array-index-key */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Body from '../typography/Body';
import Title from '../typography/Title';

import styles from '../../../styles/partials/description.module.css';

const propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    body: PropTypes.string,
    className: PropTypes.string,
    titleClassName: PropTypes.string,
    bodyClassName: PropTypes.string,
};

function Description({
    title = null,
    body = null,
    className = null,
    titleClassName = null,
    bodyClassName = null,
}) {
    return (
        <div className={classNames([styles.container, { [className]: className !== null }])}>
            {title !== null ? (
                <Title
                    className={classNames([
                        styles.title,
                        { [titleClassName]: titleClassName !== null },
                    ])}
                    size="medium"
                >
                    {title}
                </Title>
            ) : null}
            {body !== null ? (
                <Body
                    className={classNames([
                        styles.body,
                        { [bodyClassName]: bodyClassName !== null },
                    ])}
                    body={body}
                />
            ) : null}
        </div>
    );
}

Description.propTypes = propTypes;

export default Description;
